// extracted by mini-css-extract-plugin
module.exports = {"c-brand-truth":"BrandTruth_c-brand-truth__yoX57","visible":"BrandTruth_visible__jSSSU","gradient":"BrandTruth_gradient__x_0NG","text":"BrandTruth_text__MACVt"};